import Vue from "vue";
import Vuex from "vuex";
import OrderModule from "@/store/order.js";
import AppModule from "@/store/app.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app: AppModule,
    order: OrderModule
  }
});
